export default __webpack_public_path__ + "static/media/pictogramBeaconLock128.3c483906.svg";